module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.percentage !== 100) ? _c('el-progress', {
    attrs: {
      "percentage": _vm.percentage,
      "status": "danger"
    }
  }) : _c('el-progress', {
    attrs: {
      "percentage": _vm.percentage,
      "status": "success"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241cd132","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/ProgressBar.vue
// module id = 281
// module chunks = 1